import '../Sass/App.scss';
import React, { useState } from 'react';
import { Card } from './Card2';
import { Modify } from './Modify';
import { useDrop } from 'react-dnd';
import Dialog from '@mui/material/Dialog';

export function Hand (props) {

    const [modalOpen, setModalOpen] = useState(false)
    const [cardInFocus, setCardInFocus] = useState({cardData: null, indexInSeries: null})
    const [modifyOpen, setModifyOpen] = useState(false)

    const [{ isOver }, dropRef] = useDrop({
        accept: ['dev-card','ml-card','viral-card'],
        drop: (item) => {
            const dragIndex = item.indexInSeries
            item.sendHandler(dragIndex, 1)
            addToHand(item.cardData, 0)
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })

    function reorder(dragIndex, dropIndex) {
        const currentHand = [...props.cards]
        const updatedHand = []
        currentHand.forEach((card, index) => {
            if (dragIndex > dropIndex && dropIndex < index && index <= dragIndex) {
                index == (dropIndex + 1) ? updatedHand[index] = currentHand[dragIndex] : updatedHand[index] = currentHand[index-1]
            } else if (dragIndex < dropIndex && dropIndex >= index && index >= dragIndex) {
                index == dropIndex ? updatedHand[index] = currentHand[dragIndex] : updatedHand[index] = currentHand[index+1]
            } else {
                updatedHand[index] = currentHand[index]
            }
        })
        props.setCards(updatedHand)
    }

    function removeFromHand(cardIndex) {
        const currentHand = [...props.cards]
        const newHand = [
            ...currentHand.slice(0,cardIndex),
            ...currentHand.slice(cardIndex+1, currentHand.length)
        ];
        props.setCards(newHand)
        setModalOpen(false)
    }

    function addToHand(card, position) {
        const currentHand = [...props.cards]
        props.setCards([
            ...currentHand.slice(0,position+1),
            card,
            ...currentHand.slice(position+1, currentHand.length)
        ])
    }

    function expandCard(cardData, indexInSeries) {
        setCardInFocus({ cardData: cardData, indexInSeries: indexInSeries })
        setModalOpen(true)
    }

    function modifyCard() {
        setModalOpen(false)
        setModifyOpen(true)
    }

    function changeCardData(position, newData) {
        const currentHand = [...props.cards]
        props.setCards([
            ...currentHand.slice(0,position),
            newData,
            ...currentHand.slice(position+1, currentHand.length)
        ])
        setModifyOpen(false)
    }

    return (
        <>
        <div style={{display: 'block', float: 'left', minWidth: props.currentHome == 'searching' ? null : ((props.cardWidth + 11 - (props.cardWidth / 1.5)) * props.cards.length) + (props.cardWidth/1.25), marginBottom: props.handType == 'virus' ? ((props.cardWidth * 1.4)/1.4)*-1 : 'inherit', maxWidth: props.currentHome == 'searching' ? '85%' : null }}>
            { props.cards.map((card, index) =>
                <Card currentHome={props.currentHome} clickHandler={expandCard} sendHandler={removeFromHand} reorderHandler={reorder} receiveHandler={addToHand} cardData={card} codebase={props.codebase} cardWidth={props.cardWidth} cardStyle='hand' key={index} indexInSeries={index} />
            )}
            { (props.cards.length < 1 && props.handType == 'developer') ? 
                <div className='hand-empty' style={{height: props.cardWidth * 1.4 - 40, width: props.cardWidth - 40, padding: 20, fontSize: props.cardWidth / 12 }} ref={dropRef}>
                    <p><b>Empty hand!</b></p><p className='green-code'>Drag cards from a deck to draw.</p>
                </div> 
            : null }
        </div>
        <Dialog
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            PaperProps={{sx: {bgcolor: 'transparent'}}}
            >
                <Card cardData={cardInFocus.cardData} indexInSeries={cardInFocus.indexInSeries} cardWidth={500} showQuantity={false} options={true} sendHandler={removeFromHand} modifyHandler={modifyCard} notDraggable />
                <button className="close-button" style={{right: 0, top: 0, zIndex: 2500}} onClick={() => setModalOpen(false)}>X</button>
        </Dialog>
        <Dialog
            open={modifyOpen}
            maxWidth='xl'
            fullWidth={true}
            onClose={() => setModifyOpen(false)}
            PaperProps={{sx: {bgcolor: 'black', border: 1, borderColor: 'white', padding: 3, color: 'white'}}}
            >
                <Modify cardData={cardInFocus.cardData} indexInSeries={cardInFocus.indexInSeries} changeHandler={changeCardData} setModifyOpen={setModifyOpen} />
        </Dialog>
        </>
    )

}